export default {
	data() {
		return { internalPopoverIsVisible: false, };
	},
	computed: {
		popoverIsVisible() {
			return this.internalPopoverIsVisible;
		}
	},
	methods: {
		popoverSetVisible() {
			this.internalPopoverIsVisible = true;
		},
		popoverSetHidden() {
			this.internalPopoverIsVisible = false;
		},
		popoverToggle() {
			this.internalPopoverIsVisible = !this.internalPopoverIsVisible;
		},
		_popoverOnWindowClicked(event) {
			let { target } = event;
			if (this.internalPopoverIsVisible && !this.$el.contains(target) && !this._popoverIsClickInsidePortal(target)) {
				this.popoverSetHidden();
			}
		},
		_popoverIsClickInsidePortal(target) {
			let portal = document.querySelector('#popover-portal');
			if (!portal) return false;

			return portal.contains(target);
		},
		_popoverOnKeyDown(event) {
			this._popoverOnEscapeDown(event);
		},
		_popoverOnEscapeDown(event) {
			if (event.key !== 'Escape' || !this.internalPopoverIsVisible) return;

			this.popoverSetHidden();
			event.preventDefault();
			event.stopPropagation();
		}

	},
	created() {
		window.addEventListener('click', this._popoverOnWindowClicked);
		this.$nextTick(() => {
			this.$el.addEventListener('keydown', this._popoverOnKeyDown, { capture: true });
		});
	},
	destroyed() {
		window.removeEventListener('click', this._popoverOnWindowClicked);
		this.$el.removeEventListener('keydown', this._popoverOnKeyDown, { capture: true });
	}
};